import './anchorblock.less'

import {m} from '@codeurs/front'
import {FunctionComponent} from 'react'
import {slugify} from 'util/slugify'
import {style} from 'util/style'
import {Block} from './blocks'

const styles = style('anchorblock')

export const AnchorBlock: FunctionComponent<{id: string}> = ({id}) => {
	return <Block class={styles} id={slugify(id)} />
}
